import { isRevolvingCreditProduct } from './productTypeHelpers';
const isDCHSettlementEnrolled = (billing, productType, featureFlags) => {
    const isSettlementEnrolled = billing === null || billing === void 0 ? void 0 : billing.settlementEnrolled;
    const isRevolvingCredit = isRevolvingCreditProduct(productType);
    return (featureFlags.isDigitalCollectionsEnabled &&
        isRevolvingCredit &&
        isSettlementEnrolled);
};
export default isDCHSettlementEnrolled;
